export default async function initMediathek() {
  const carouselEls = document.querySelectorAll('[data-carousel]');
  if (carouselEls.length) {
    const { default: initCarousel } = await import(
      /* webpackChunkName: "mediathek-carousel" */ './mediathek-carousel'
    );
    carouselEls.forEach(el => initCarousel(el));
  }

  const galleryEl = document.querySelector('[data-gallery]');
  if (galleryEl) {
    const { default: initGallery } = await import(
      /* webpackChunkName: "mediathek-gallery" */ './mediathek-gallery'
    );
    initGallery(galleryEl);
  }

  const searchEl = document.querySelector('[data-mediathek-search]');
  if (searchEl) {
    const { default: initMediathekSearch } = await import(
      /* webpackChunkName: "mediathek-search" */ './mediathek-search'
    );
    initMediathekSearch(searchEl);
  }
}
